/* src/app/modules/product-labels/label-remove-button/label-remove-button.component.scss */
.remove-button-container {
  filter: drop-shadow(0px 3px 7px grey);
  background-color: white;
  cursor: pointer;
}
.x-icon {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=label-remove-button.component.css.map */
